import React from 'react';
import { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';

import { StyledTable } from '../../common/tableView.styles';
import { CandidateRecruitmentType } from '../candidates/Candidates.types';

type PropagateTableProps = {
  recruitments: CandidateRecruitmentType[];
  chooseRecruitment: (propagate: React.Key[]) => void;
};

const StyledPropagateTable = styled(StyledTable)`
  .ant-table-container,
  .ant-table-header {
    font-size: 12px;
  }
`;

const columns: ColumnsType<CandidateRecruitmentType> = [
  {
    title: 'Project',
    dataIndex: 'project',
    width: 120,
  },
  {
    title: 'Client',
    dataIndex: 'client',
    width: 120,
  },
  {
    title: 'Project status',
    dataIndex: 'projectStatus',
    render: (active: boolean) => <div>{active ? 'active' : 'inactive'}</div>,
    width: 120,
  },
  {
    title: 'Recruitment status',
    dataIndex: 'recruitmentStatus',
    width: 120,
  },
];

export const PropagateTable: React.FC<PropagateTableProps> = ({ recruitments, chooseRecruitment }) => {
  const dataSource = recruitments.map((element) => {
    return {
      key: element.uuid,
      project: element.project.name,
      client: element.project.client.name,
      projectStatus: element.project.active,
      recruitmentStatus: element.status.name,
    };
  });

  return (
    <StyledPropagateTable
      columns={columns}
      dataSource={dataSource}
      scroll={{ y: dataSource.length ? window.innerHeight - 650 : 120 }}
      pagination={false}
      bordered
      size="small"
      rowSelection={{
        type: 'checkbox',
        onChange: (selectedRowKeys: React.Key[]) => {
          chooseRecruitment(selectedRowKeys);
        },
      }}
    />
  );
};
